import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { WorkspacesPage } from './pages/Workspaces';
import { ProjectsPage } from './pages/Projects';
import { BoardPage } from './pages/Board';
import { ListPage } from './pages/List';
import { GanttPage } from './pages/Gantt';
import { Cycles } from './pages/Cycles';
import { Modules } from './pages/Modules';
import { SettingsPage } from './pages/Settings';
import { Pages } from './pages/Pages';
import { Analytics } from './pages/Analytics';
import { Views } from './pages/Views';
import { Inbox } from './pages/Inbox';
import { Epics } from './pages/Epics';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Navigate to="/workspaces" replace />} />
        <Route path="/workspaces" element={<WorkspacesPage />} />
        <Route path="/workspaces/:workspaceId" element={<ProjectsPage />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId" element={<Navigate to="board" replace />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/board" element={<BoardPage />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/list" element={<ListPage />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/gantt" element={<GanttPage />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/cycles" element={<Cycles />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/modules" element={<Modules />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/epics" element={<Epics />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/pages" element={<Pages />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/views" element={<Views />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/analytics" element={<Analytics />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/inbox" element={<Inbox />} />
        <Route path="/workspaces/:workspaceId/projects/:projectId/settings" element={<SettingsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
